import { useMemo } from 'react'
import layoutConfig from './layout-config'
import { ERROR_LAYOUT, MAIN_LAYOUT, RESTRICTED_LAYOUT, WITHOUT_LAYOUT } from './variants'
import { useStore } from '@bluheadless/ui-logic/src/providers/store'

const Layout = ({
	Component,
	layoutProps,
	nestedLayoutProps,
	isError = false,
	isMaintenance = false,
	entityLayout,
	restrictionEnabled,
	children,
}) => {
	const _layoutProps = useMemo(
		() => ({ layout: Component?.layout ?? layoutProps ?? {} }),
		[Component?.layout, layoutProps]
	)
	const _nestedLayoutProps = useMemo(
		() => ({ layout: Component?.nestedLayout ?? nestedLayoutProps ?? {} }),
		[Component?.nestedLayout, nestedLayoutProps]
	)
	const store = useStore()

	const LayoutRoot = useMemo(() => {
		const needLayout = !isError && !isMaintenance && store?.code

		const needErrorLayout = isError || (!Component?.withLayout && !store?.code)

		const baseLayoutCode = Component?.withLayout ?? entityLayout ?? MAIN_LAYOUT

		const restrictedLayoutCode = Component?.withRestrictedLayout ?? RESTRICTED_LAYOUT

		const defaultLayoutCode = needLayout
			? restrictionEnabled
				? RESTRICTED_LAYOUT
				: MAIN_LAYOUT
			: needErrorLayout
			? ERROR_LAYOUT
			: WITHOUT_LAYOUT

		const layoutCode = needLayout
			? restrictionEnabled
				? restrictedLayoutCode ?? baseLayoutCode
				: baseLayoutCode
			: needErrorLayout
			? ERROR_LAYOUT
			: WITHOUT_LAYOUT

		return layoutConfig?.[layoutCode] ?? layoutConfig[defaultLayoutCode]
	}, [
		isError,
		isMaintenance,
		store?.code,
		Component?.withLayout,
		Component?.withRestrictedLayout,
		entityLayout,
		restrictionEnabled,
	])

	return (
		<LayoutRoot nestedLayoutProps={_nestedLayoutProps} {..._layoutProps}>
			{children}
		</LayoutRoot>
	)
}
export default Layout
